type DeltaEstimatedTimeType = {
  days: number;
  hours: number;
  mins: number;
};

const DAY_IN_MINS = 60 * 24;
const HOUR_IN_MINS = 60;

function truncate(num: number) {
  const partialResult = Math.trunc(num);
  return partialResult === -0 ? Math.abs(partialResult) : partialResult;
}

export const getDeltaTime = (minsAmnt: number): DeltaEstimatedTimeType => {
  const days = truncate(minsAmnt / DAY_IN_MINS);
  const hours = truncate((minsAmnt - days * DAY_IN_MINS) / HOUR_IN_MINS);
  const mins = minsAmnt - hours * HOUR_IN_MINS - days * DAY_IN_MINS;

  return {
    days,
    hours,
    mins,
  };
};
